
import Header from "./landing/Header";
import Access from "./landing/Access";
import Platform from "./landing/Platform";
import Features from "./landing/Features";
import Trusted from "./landing/Trusted";
import Ecosystem from "./landing/Ecosystem";
import Quote from "./landing/Quote";

import Navbar from "./Navbar";
import Footer from "./landing/Footer";
import HomeHeader from "./HomeHeader";
function Home() {
  
  return (
    <div className="max-w-screen-xl mx-auto bg-dark min-h-screen">
      <HomeHeader />
      <section id="home">
        <Header  />
      </section>
      <section id="access">
        <Access />
      </section>
      <section id="platform">
        <Platform />
      </section>
      <section id="features">
        <Features />
      </section>
      <Trusted />
      <section id="ecosystem">
        <Ecosystem />
      </section>
      <Quote />
      <Footer />
    </div>
  );
}

export default Home;
